export interface EditorFormatState {
  blockType: string;
  isBold: boolean;
  isItalic: boolean;
  isStrikethrough: boolean;
  isUnderline: boolean;
  isCode: boolean;
  isLink: boolean;
}

export interface EditorCommand {
  type: string;
  payload?: any;
}

export enum FormatCommandType {
  BOLD = 'BOLD',
  ITALIC = 'ITALIC',
  STRIKETHROUGH = 'STRIKETHROUGH',
  UNDERLINE = 'UNDERLINE',
  LINK = 'LINK',
  HEADING = 'HEADING',
  QUOTE = 'QUOTE',
  BULLET_LIST = 'BULLET_LIST',
  NUMBERED_LIST = 'NUMBERED_LIST',
  PARAGRAPH = 'PARAGRAPH'
}

export type BlockType =
  | 'paragraph'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'quote'
  | 'bullet'
  | 'number';
